import { Grid } from "@mui/material"

import { MeetingServiceOrder } from "../../../../modules/merchant/accounting/accounting/accountingTypes"
import { MeetingServiceFormContainer } from "../components/meetingService/MeetingServiceFormContainer"
import { MainOrderFormikRef, MeetingServiceTabValues } from "../components/form/formTypes"
import { ResourceBookingWrapper } from "../components/resource/ResourceBookingWrapper"
import { OrderFormStatus } from "./helpers"
import { CreateOrderType } from "../helpers"

type TabContentProps = Readonly<{
    handleChangeOrderType: (type: CreateOrderType) => void
    orderFormStatusRef: React.MutableRefObject<OrderFormStatus>
    handleOpenSelectPriceListsDialog: () => void
    orderDetails?: MeetingServiceOrder
    handleSubmitMeetingService: (values: MeetingServiceTabValues) => void
    outerFormik: MainOrderFormikRef
    isSpecialOrder: boolean
    contentSlideClassName: string
}>

export function buildTabContent({
    handleChangeOrderType,
    orderFormStatusRef,
    handleOpenSelectPriceListsDialog,
    orderDetails,
    handleSubmitMeetingService,
    outerFormik,
    isSpecialOrder,
    contentSlideClassName,
}: TabContentProps) {
    const tabs = [
        {
            animationKey: CreateOrderType.RESOURCE_BOOKING,
            content: (
                <Grid container className={contentSlideClassName}>
                    <ResourceBookingWrapper
                        handleChangeOrderType={handleChangeOrderType}
                        orderFormStatusRef={orderFormStatusRef}
                        orderDetails={orderDetails}
                        outerFormik={outerFormik}
                    />
                </Grid>
            ),
            direction: "left",
        },
        {
            animationKey: CreateOrderType.MEETING_SERVICE,
            content: (
                <MeetingServiceFormContainer
                    handleOpenSelectPriceListsDialog={handleOpenSelectPriceListsDialog}
                    orderDetails={orderDetails}
                    handleSubmitMeetingService={handleSubmitMeetingService}
                    outerFormik={outerFormik}
                />
            ),
            direction: "right",
        },
    ]

    return isSpecialOrder ? tabs.filter((t) => t.animationKey === CreateOrderType.MEETING_SERVICE) : tabs
}
